module.exports = __webpack_public_path__ + "img/plan_recuperacion.df575307.png";